import React from 'react'
import { Button } from '..'

interface IProps {
    title: string
    textButton?: string
    buttonDisabled?: boolean
    onClickButton?: () => void
}

export default function HeaderPage(props: IProps): React.ReactElement {
    return (
        <div className='header-pages'>
            <h4 className="title">{props.title}</h4>
            {props.textButton ? (
                <Button placeholder={props.textButton} onClick={props.onClickButton} />
            ) : (
                <></>
            )}
        </div>
    )
}
